import React, { useState, useRef, useEffect, useCallback } from "react";
import JoinFormPopup from "../component/JoinhereForm/joinhereForm";
import FeedbackFormPopup from "../component/FeedbackForm/feedbackForm";
import { useNavigate } from 'react-router-dom';
import { fetchlanguages } from "../api/api";

function Header({ oddsFormat, setOddsFormat, language, setLanguage }) {
  const [showPopup, setShowPopup] = useState(false);
  const [feedbackPopup, setFeedbackPopup] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [languageData, setLanguageData] = useState([]);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const storedMode = localStorage.getItem("darkMode");
    return storedMode === "true";
  });
  const [activeComponent, setActiveComponent] = useState("best");
  const [showScrollLogo, setShowScrollLogo] = useState(false);
  const navigate = useNavigate();
  // const [isLoggedIn, setIsLoggedIn] = useState(() => {
  //   return !!sessionStorage.getItem("tokenId");
  // });

  useEffect(() => {
      const fetchLanguagData = async () => {
        try {
          const leagueResponse = await fetchlanguages(1,5);
          setLanguageData(leagueResponse.data)
        } catch (error) {
          console.error("Error fetching league data:", error);
        }
      };
  
      fetchLanguagData();
    }, []);


  const settingsRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
  if (settingsRef.current && !settingsRef.current.contains(event.target)) {
    setShowSettings(false);
  }
  }, [settingsRef, setShowSettings]);

  useEffect(() => {
    const handleDocumentClick = (event) => handleClickOutside(event);
    document.addEventListener("mousedown", handleDocumentClick);
    
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    document.body.classList.toggle("dark-mode", isDarkMode);
    localStorage.setItem("darkMode", isDarkMode);
  }, [isDarkMode]);

  useEffect(() => {
    const el = document.getElementById(`component-${activeComponent}`);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, [activeComponent]);

  useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 100) {
      setShowScrollLogo(true);
    } else {
      setShowScrollLogo(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const handleLogout = () => {
  //   sessionStorage.clear();
  //   setIsLoggedIn(false);
  //   navigate("/login");
  // };

  return (
    <>
    <div className="AF-settings-wrapper" ref={settingsRef}>
      {/* Mobile Header */}
      <div className="AF-topHeader-buttons block md:hidden" ref={settingsRef}>
        {["multi", "best", "treble"].map((comp) => (
          <button
            key={comp}
            className={activeComponent === comp ? "active" : ""}
            onClick={() => setActiveComponent(comp)}
          >
            {comp === "multi" ? "MultiBet" : comp === "best" ? "Bet Builder" : "Treble Win"}
          </button>
        ))}
        <button
          className="AF-settings-button"
          aria-label="Toggle Settings"
          onClick={() => setShowSettings(!showSettings)}
        >
          <SettingsIcon />
        </button>
        
        {showSettings && (
          <div className="settings-dropdown">
            <div className="dropdown-section">
              <label htmlFor="language-select-mobile">Language</label>
              <select
                id="language-select-mobile"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="custom-select"
              >
                {languageData.length > 0 ? (
                      languageData.map((item, index) => (
                        <option key={index} value={item.langid}>
                          {item.language}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        Language not available
                      </option>
                    )}
              </select>
            </div>

            <div className="dropdown-section">
              <div className="dropdown-options">
                <button
                  className={oddsFormat === "EU" ? "active" : ""}
                  onClick={() => setOddsFormat("EU")}
                >
                  EU
                </button>
                <button
                  className={oddsFormat === "US" ? "active" : ""}
                  onClick={() => setOddsFormat("US")}
                >
                  US
                </button>
              </div>
            </div>

            <div className="dropdown-section">
              <div className="dropdown-options">
                <label>Light</label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isDarkMode}
                    onChange={() => setIsDarkMode((prev) => !prev)}
                  />
                  <span className="slider round"></span>
                </label>
                <label>Dark</label>
              </div>
            </div>
            <div className="dropdown-section">
              <div className="dropdown-options">
                {/* {isLoggedIn ? (
                  <button
                    className="AF-settings-button-login"
                    aria-label="Logout"
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                ) : (
                  <>
                    <button
                      className="AF-settings-button-login"
                      onClick={() => navigate("/login")}
                    >
                      Login
                    </button>
                    <button
                      className="AF-settings-button-login"
                      onClick={() => navigate("/signup")}
                    >
                      Signup
                    </button>
                  </>
                )} */}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* <div className="AF-topHeader-buttons-login md:hidden">
        <button
          className="AF-settings-button-login"
          aria-label="Toggle Settings"
          onClick={() => navigate('/login')}
        >
          Login 
        </button>
        <button
          className="AF-settings-button-login"
          aria-label="Toggle Settings"
          onClick={() => navigate('/signup')}
        >
          Signup
        </button>
      </div> */}

      {/* Desktop Header */}
      <div className="AF-topHeader" ref={settingsRef}>
        <div className="AF-container">
          <div className="grid-noGutter-middle">
            <div className="col-6"></div>
            <div className="col-6 right-align">
              {/* {isLoggedIn ? (
                  <button
                    className="AF-settings-button-login"
                    aria-label="Logout"
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                ) : (
                  <>
                    <button
                      className="AF-settings-button-login"
                      onClick={() => navigate("/login")}
                    >
                      Login
                    </button>
                    <button
                      className="AF-settings-button-login"
                      onClick={() => navigate("/signup")}
                    >
                      Signup
                    </button>
                  </>
                )} */}
              <button
                className="AF-settings-button"
                aria-label="Toggle Settings"
                onClick={() => setShowSettings(!showSettings)}
              >
                <SettingsIcon />
              </button>

              {showSettings && (
                <div className="settings-dropdown">
                  <div className="dropdown-section">
                    <label htmlFor="language-select">Language</label>
                    <select
                      id="language-select"
                      value={language}
                      onChange={(e) => setLanguage(e.target.value)}
                      className="custom-select"
                    >
                      {languageData.length > 0 ? (
                      languageData.map((item, index) => (
                        <option key={index} value={item.langid}>
                          {item.language}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        Language not available
                      </option>
                    )}
                    </select>
                  </div>

                  <div className="dropdown-section">
                    <div className="dropdown-options">
                      <button
                        className={oddsFormat === "EU" ? "active" : ""}
                        onClick={() => setOddsFormat("EU")}
                      >
                        EU
                      </button>
                      <button
                        className={oddsFormat === "US" ? "active" : ""}
                        onClick={() => setOddsFormat("US")}
                      >
                        US
                      </button>
                    </div>
                  </div>

                  <div className="dropdown-section">
                    <div className="dropdown-options">
                      <label>Light</label>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={isDarkMode}
                          onChange={() => setIsDarkMode((prev) => !prev)}
                        />
                        <span className="slider round"></span>
                      </label>
                      <label>Dark</label>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

      {/* Beta Message */}
      <div className="AF-container beta-hide">
        <div className="beta-message">
          <p>
            You’re using the free{" "}
            <strong>
              <a href="/theme" className="beta-link">Beta</a>
            </strong>{" "}
            of Best Bets.
            <br />
            Pro features coming soon —{" "}
            <span className="beta-link" onClick={() => setShowPopup(true)}>
              Join early access
            </span>{" "}
            or{" "}
            <span className="beta-link" onClick={() => setFeedbackPopup(true)}>
              Leave feedback
            </span>
            .
          </p>
        </div>
      </div>

      {/* Popups */}
      {showPopup && <JoinFormPopup onClose={() => setShowPopup(false)} />}
      {feedbackPopup && <FeedbackFormPopup onClose={() => setFeedbackPopup(false)} />}
      {showScrollLogo && (
        <div className="scroll-logo" onClick={handleLogoClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path fillRule="evenodd" d="M8 12a.5.5 0 0 1-.5-.5V4.707L4.354 8.854a.5.5 0 1 1-.708-.708l4.5-4.5a.5.5 0 0 1 .708 0l4.5 4.5a.5.5 0 0 1-.708.708L8.5 4.707V11.5A.5.5 0 0 1 8 12z" />
          </svg>
        </div>
      )}
</>

  );
}

// Reusable Icon Component
const SettingsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 15.5A3.5 3.5 0 1 1 15.5 12 3.5 3.5 0 0 1 12 15.5Zm9.1-3.4a7.54 7.54 0 0 0-.2-1.7l2-1.5a.5.5 0 0 0 .1-.7l-2-3.5a.5.5 0 0 0-.6-.2l-2.3 1a6.3 6.3 0 0 0-1.4-.8l-.4-2.5a.5.5 0 0 0-.5-.4H9.4a.5.5 0 0 0-.5.4l-.4 2.5a6.3 6.3 0 0 0-1.4.8l-2.3-1a.5.5 0 0 0-.6.2l-2 3.5a.5.5 0 0 0 .1.7l2 1.5a7.54 7.54 0 0 0-.2 1.7 7.54 7.54 0 0 0 .2 1.7l-2 1.5a.5.5 0 0 0-.1.7l2 3.5a.5.5 0 0 0 .6.2l2.3-1a6.3 6.3 0 0 0 1.4.8l.4 2.5a.5.5 0 0 0 .5.4h4.2a.5.5 0 0 0 .5-.4l.4-2.5a6.3 6.3 0 0 0 1.4-.8l2.3 1a.5.5 0 0 0 .6-.2l2-3.5a.5.5 0 0 0-.1-.7l-2-1.5a7.54 7.54 0 0 0 .2-1.7Z" />
  </svg>
);

export default Header;
